import { PositionType } from './calculate-position';

type Rect = Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left' | 'width' | 'height'>;
type Bounds = Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left'>;

export const calculateContainedPosition = (
    position: PositionType,
    trigger: Rect,
    floating: Pick<Rect, 'width' | 'height'>,
    bounds: Bounds,
    gap = 16,
) => {
    let adjustedPosition = position;
    const above = trigger.top - floating.height - gap;
    const below = trigger.bottom + gap;
    const fitsAbove = above >= bounds.top;
    const fitsBelow = below + floating.height <= bounds.bottom;

    if (position.startsWith('top') && !fitsAbove && fitsBelow) {
        adjustedPosition = position.replace('top', 'bottom') as PositionType;
    } else if (position.startsWith('bottom') && !fitsBelow && fitsAbove) {
        adjustedPosition = position.replace('bottom', 'top') as PositionType;
    }

    const requestedTop = adjustedPosition.startsWith('top') ? above : below;
    let requestedLeft = trigger.left + trigger.width / 2 - floating.width / 2;
    if (adjustedPosition.endsWith('left')) requestedLeft = trigger.left;
    if (adjustedPosition.endsWith('right')) requestedLeft = trigger.right - floating.width;

    const left = Math.max(bounds.left, Math.min(requestedLeft, bounds.right - floating.width));
    const top = Math.max(bounds.top, Math.min(requestedTop, bounds.bottom - floating.height));
    const arrowLeft = Math.max(16, Math.min(trigger.left + trigger.width / 2 - left, floating.width - 16));

    return { top, left, adjustedPosition, arrowLeft };
};
